import { useEffect, useRef } from 'react';
import { useExam } from '../context/ExamContext';
import { useUpdateUserReadingAnswers, useUpdateUserWritingAnswers, useUpdateUserListeningAnswers } from "../services/index";

export function useExamServerDataOperations({ autoSave = true } = {}) {
  const {
    answers,
    writingAnswers,
    listeningAnswers,
    readingAnswers,
    activeView,
    productType,
    uprId
  } = useExam();
  const intervalMs = 30_000;
  // const answersRef = useRef(answers);

  // useEffect(() => {
  //   answersRef.current = answers;
  // }, [answers]);


  const readingApi = useUpdateUserReadingAnswers();
  const listeningApi = useUpdateUserListeningAnswers();
  const writingApi = useUpdateUserWritingAnswers();


  const bulkUpdate = () => {

    if (["reading", "listening", "writing"].includes(productType)) {
      try {
        if (productType == "reading" && readingAnswers?.length > 0) {
          readingApi?.updateBulk({ answers: readingAnswers, uprId });
        }
        if (productType == "listening" && listeningAnswers?.length > 0) {
          listeningApi?.updateBulk({ answers: listeningAnswers, uprId });
        }
        if (productType == "writing" && writingAnswers?.length > 0) {
          writingApi?.updateBulk({ answers: writingAnswers, uprId });
        }
      } catch (error) {
        console.error("Error:", error.message);
      }
    }


    if (productType == "exam") {
      if (Array.isArray(readingAnswers) && readingAnswers.length > 0) {
        readingApi?.updateBulk({ answers: readingAnswers, uprId });
      }
      if (Array.isArray(listeningAnswers) && listeningAnswers.length > 0) {
        listeningApi?.updateBulk({ answers: listeningAnswers, uprId });
      }
      if (Array.isArray(writingAnswers) && writingAnswers.length > 0) {
        writingApi?.updateBulk({ answers: writingAnswers, uprId });
      }
    }
  };

  useEffect(() => {
    if (!autoSave) return;
    // console.log("HERE CHECK ME >>> ", activeView);

    if (["reading", "listening", "writing"].includes(activeView)) {
      const id = setInterval(bulkUpdate, intervalMs);
      return () => clearInterval(id);
    }
  }, [autoSave, intervalMs, activeView, bulkUpdate]);

  return bulkUpdate;
}
